/**
 * Builder-UI labels for matrix rows / per-asset bindings, derived from the
 * actual tested-asset type instead of hardcoded "concept" / "landing page"
 * wording (which is wrong/confusing on ad, brand, message, packaging studies).
 */

const BINDING_NOUN: Record<string, string> = {
  concept: "concept",
  ad: "ad",
  landing_page: "landing page",
  brand: "brand",
  message: "message",
  packaging: "package",
  pain: "pain",
  product: "product",
};

/** Singular noun for the per-asset "one per <X>" chip. */
export function assetBindingNoun(assetType: string | null | undefined): string {
  return (assetType && BINDING_NOUN[assetType]) || "asset";
}

/**
 * Singular noun with its article, for copy that reads "add it as ___".
 * "ad" is the only vowel-initial asset noun today, but the rule is the rule
 * rather than a special case for it.
 */
export function assetBindingNounWithArticle(
  assetType: string | null | undefined,
): string {
  const noun = assetBindingNoun(assetType);
  return `${/^[aeiou]/i.test(noun) ? "an" : "a"} ${noun}`;
}
